import React, { useEffect, useMemo } from 'react';
// import { Outlet } from 'react-router-dom';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, Container, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';


// project imports
import Header from '../../layouts/berry/MainLayout/Header';
import Sidebar from '../../layouts/berry/MainLayout/Sidebar';
import HorizontalBar from '../../layouts/berry/MainLayout/HorizontalBar';
import Breadcrumbs from '../berry/ui-component/extended/Breadcrumbs';

// project imports
import Footer from '../../layouts/berry/MainLayout/Footer';
import navigation from '../../menu-items';
import LAYOUT_CONST from '../../constant';
import useConfig from '../../hooks/useConfig';
import { drawerWidth } from '../../store/appConstant';
import { openDrawer } from '../../store/slices/menuSlice';
import { useDispatch, useSelector } from 'react-redux';

// assets
import { IconChevronRight } from '@tabler/icons-react';
import Loader from "./Loader";

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open, layout }) => ({
    ...theme.typography.mainContent,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    padding: 0,
    marginBottom: 20,
    height: `calc(100vh - 100px)`,
    flexGrow: 1,     // Ensures the main content grows to fill available space
    overflow: 'auto', // Enables scrolling when content is too long
    ...(!open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.shorter + 200
        }),
        [theme.breakpoints.up('md')]: {
            marginLeft: layout === LAYOUT_CONST.VERTICAL_LAYOUT ? -(drawerWidth - 72) : '20px',
            width: `calc(100% - ${drawerWidth}px)`,
            marginTop: layout === LAYOUT_CONST.HORIZONTAL_LAYOUT ? 100 : 80
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shorter + 200
        }),
        marginLeft: layout === LAYOUT_CONST.HORIZONTAL_LAYOUT ? '20px' : 0,
        marginTop: layout === LAYOUT_CONST.HORIZONTAL_LAYOUT ? 100 : 80,
        width: `calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.up('md')]: {
            marginTop: layout === LAYOUT_CONST.HORIZONTAL_LAYOUT ? 100 : 80
        }
    }),
    [theme.breakpoints.down('md')]: {
        marginLeft: '20px',
        padding: '16px',
        marginTop: 80,
        ...(!open && {
            width: `calc(100% - ${drawerWidth}px)`
        })
    },
    [theme.breakpoints.down('sm')]: {
        marginLeft: '10px',
        marginRight: '10px',
        padding: '16px',
        marginTop: 50,
        ...(!open && {
            width: `calc(100% - ${drawerWidth}px)`
        })
    }
}));

const TemplateBerryPrivate = ({ children }) => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);
    const { user, state } = useSelector((state) => state.account);
    const { drawerType, container, layout } = useConfig();

    useEffect(() => {
        if (drawerType === LAYOUT_CONST.DEFAULT_DRAWER) {
            dispatch(openDrawer(true));
        } else {
            dispatch(openDrawer(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerType]);

    useEffect(() => {
        if (drawerType === LAYOUT_CONST.DEFAULT_DRAWER) {
            dispatch(openDrawer(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (matchDownMd) {
            dispatch(openDrawer(false));
        }
        if (matchUpMd) {
            dispatch(openDrawer(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);

    const condition = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd;

    const header = useMemo(
        () => (
            <Toolbar sx={{ p: condition ? '10px' : '5px 10px' }}>
                <Header />
            </Toolbar>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [layout, matchDownMd]
    );

    if (state === "online") {
        return (
            <Box sx={{ display: 'flex',  minHeight: '100vh' }}>
                <CssBaseline />
                <AppBar enableColorOnDark position="fixed" color="inherit" elevation={0} sx={{ bgcolor: theme.palette.background.default }}>
                    {header}
                </AppBar>

                {layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd && <HorizontalBar />}

                {(layout === LAYOUT_CONST.VERTICAL_LAYOUT || matchDownMd) && <Sidebar />}

                <Main theme={theme} open={drawerOpen} layout={layout} sx={{ flex: 1, mb: 2 }} className="bg-class">
                    <Container maxWidth={container ? 'lg' : false} {...(!container && { sx: { px: { xs: 2 } } })}>
                        <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                        {children}
                    </Container>
                </Main>
                <Footer />
            </Box>

        );
    } else {
        return <Loader open />
    }
};

export default TemplateBerryPrivate;
